import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Relatório Afastamentos',
    path: '/pessoal/relatorioafastamento',
    name: 'relatorioafastamento',
    component: () => import('@/views/pessoal/relatorioafastamento/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.RELATORIOAFASTAMENTOSNOVO_MENU_1400200198],
    },
    goesToMenu: true,
  },
];
